/* No transitions: the palette opens and closes many times a day (motion restraint). */
.backdrop {
  position: fixed;
  inset: 0;
  background: var(--color-overlay);
}

.viewport {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12dvh var(--space-4) var(--space-4);
}

.popup {
  display: flex;
  flex-direction: column;
  inline-size: min(100%, var(--palette-width));
  max-block-size: min(36rem, calc(100dvh - 16dvh));
  overflow: hidden;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  color: var(--color-text);
  box-shadow: var(--shadow-modal);
  outline: 0;
}

.inputGroup {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  padding-inline: var(--space-4) var(--space-3);
  border-block-end: var(--border-width) solid var(--color-border);
}

.inputIcon {
  color: var(--color-text-subtle);
}

.input {
  flex: 1;
  min-inline-size: 0;
  block-size: var(--space-12);
  border: 0;
  background: transparent;
  color: var(--color-text);
  font-size: var(--text-lg);
  outline: none;
}

.input:focus-visible {
  outline: none;
}

.escHint {
  flex: none;
}

.hiddenClose {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.listArea {
  flex: 1 1 auto;
  min-block-size: 0;
  padding: var(--space-1);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.group {
  display: flex;
  flex-direction: column;
}

.groupLabel {
  padding: var(--space-2) var(--space-3) var(--space-1);
  color: var(--color-text-muted);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
}

.item {
  display: grid;
  grid-template-columns: var(--icon-sm) minmax(0, 1fr) auto;
  gap: var(--space-3);
  align-items: center;
  min-block-size: var(--control-lg);
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-md);
  color: var(--color-text);
  font-size: var(--text-md);
  cursor: default;
  user-select: none;
}

.item[data-highlighted] {
  background: var(--color-accent-subtle);
}

.itemIcon {
  display: inline-flex;
  color: var(--color-text-subtle);
}

.item[data-highlighted] .itemIcon {
  color: var(--color-accent);
}

.itemLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itemDetail {
  color: var(--color-text-subtle);
  font-size: var(--text-sm);
  white-space: nowrap;
}

.empty {
  padding: var(--space-6) var(--space-4);
  color: var(--color-text-muted);
  font-size: var(--text-md);
  text-align: center;
}

.empty:empty {
  display: none;
}

.footer {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  justify-content: space-between;
  min-block-size: var(--control-md);
  padding: var(--space-1) var(--space-4);
  border-block-start: var(--border-width) solid var(--color-border);
  color: var(--color-text-subtle);
  font-size: var(--text-xs);
}

.status {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  min-inline-size: 0;
}

.hints {
  display: inline-flex;
  flex: none;
  gap: var(--space-1);
  align-items: center;
  margin-inline-start: auto;
}

@media (pointer: coarse) {
  .hints {
    display: none;
  }
}
